<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);">
            <i class="fa fa-check-square-o text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Contas Recebidas</h4>
            <small class="text-muted small">Histórico de recebimentos e baixas</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-code-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-select class="border-0 bg-transparent font-weight-bold text-dark mr-2" style="width: auto;" v-model="tipoData" :options="optionsSituacao"/>
                    <cec-input-data ref="edDT1" v-model="dt1" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="edDT2" v-model="dt2" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                </div>

                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="modal-label-premium">Nº Documento</label>
                      <b-form-input type="text" v-model="documento" placeholder="Ex: 12345" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="modal-label-premium">Cod. Controle</label>
                      <b-form-input type="text" v-model="id" placeholder="Ex: 987" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="8">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Cliente"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table ref="tbl" 
                    id="table-transition-example"        
                    class="mb-0 table-finance"
                    :dark="isDark"
                    primary-key="SEQUENCIA"
                    responsive  hover  small  show-empty
                    empty-text="Informe o filtro para ver os registros "
                    :busy.sync="isBusy" 
                    :sticky-header="stickyHeight"
                    :tbody-tr-class="rowClassSelecionado"
                    :items="itensFiltrados" 
                    :fields="tabelaListagem.fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @row-clicked="clicarLinha"
                    >
            <template #head(DOCUMENTO)>
              <SetFilter
                label="DOCUMENTO"
                v-model="filtros.DOCUMENTO"
                :options="opcoes.DOCUMENTO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(PARCELAS)>
              <SetFilter
                label="Parc."
                v-model="filtros.PARCELAS"
                :options="opcoes.PARCELAS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(ITENS)>
              <SetFilter
                label="Descrição"
                v-model="filtros.ITENS"
                :options="opcoes.ITENS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(TIPO_BAIXA)>
              <SetFilter
                label="Tipo"
                v-model="filtros.TIPO_BAIXA"
                :options="opcoes.TIPO_BAIXA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(NOME_CLIENTE)>
              <SetFilter
                label="Cliente"
                v-model="filtros.NOME_CLIENTE"
                :options="opcoes.NOME_CLIENTE"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(DT_VENCAPAGAR)>
              <SetFilter
                label="Documento"
                v-model="filtros.DT_VENCAPAGAR"
                :options="opcoes.DT_VENCAPAGAR"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(DT_BAIXA)>
              <SetFilter
                label="Baixa"
                v-model="filtros.DT_BAIXA"
                :options="opcoes.DT_BAIXA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(DT_SISTEMA)>
              <SetFilter
                label="Sistema"
                v-model="filtros.DT_SISTEMA"
                :options="opcoes.DT_SISTEMA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(VL_DOC)>
              <SetFilter
                label="VL. Doc"
                v-model="filtros.VL_DOC"
                :options="opcoes.VL_DOC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(VL_BAIXA)>
              <SetFilter
                label="Pago"
                v-model="filtros.VL_BAIXA"
                :options="opcoes.VL_BAIXA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
        
        <template #cell(OP_TIPO_PAGAMENTO)="item">
          <b-badge pill class="px-2 py-1 shadow-xs" :variant="variantTipoPagamento(item.item.OP_TIPO_PAGAMENTO)">
            <i :class="iconeTipoPagamento(item.item.OP_TIPO_PAGAMENTO)" class="mr-1"></i>
            {{ descricaoTipoPagamento(item.item.OP_TIPO_PAGAMENTO) }}
          </b-badge>
        </template>
        
        <template #cell(TIPO_BAIXA)="item">
          <b-badge pill class="px-3 py-1 shadow-xs" :variant="colorirTipoBaixa(item.item.TIPO_BAIXA)">{{item.item.TIPO_BAIXA}}</b-badge>
        </template>      
        <template #cell(NOME_CLIENTE)="item">
          <div class="font-weight-bold text-dark">{{ item.item.NOME_CLIENTE }}</div>
          <small class="text-muted">Cód: {{ item.item.COD_CLI }}</small>
        </template>      
        
        <template #cell(actions)="item">
          <b-button 
                  type="button" 
                  @click.stop.prevent="abrirModalEstorno(item.item)" 
                  size="sm" 
                  variant="soft-danger" pill class="btn-icon-only shadow-sm"
                  title="Estornar" 
                  v-b-popover.hover.left="'Estornar Recebimento'" >
            <i class="fa fa-times"></i>
          </b-button>
        </template>
        <template #empty>
          <div class="h-100 d-flex align-items-center justify-content-center p-5">
            <div class="text-center">
                <i class="fa fa-search fa-3x text-muted mb-3"></i>
                <p class="text-muted font-weight-bold">Nenhum registro encontrado para os filtros aplicados.</p>
            </div>
          </div>
        </template>
        <!-- Alternativamente, usando custom-foot para linha de rodapé completa -->
        <template #custom-foot="{ fields, items }">
          <b-tr class="bg-light font-weight-bold">
            <b-td v-for="(field, idx) in fields" :key="idx" :class="field.class">
              <span v-if="field.key === 'DOCUMENTO'" class="text-center d-block">({{ itensFiltrados.length }})</span>
              <span v-if="field.key === 'DT_BAIXA'" class="text-right d-block">TOTAIS:</span>
              
              <span v-if="field.key === 'VL_BAIXA'" class="text-right text-dark">{{ vlPagoRodape }}</span>
            </b-td>
          </b-tr>
        </template>
      </b-table>
          </div>
        </b-col>
      </b-row>
      <div>
      <!--  -----------------------------------------------------------------------------------
                                          MODAL ESTORNO 
            ----------------------------------------------------------------------------------- -->
        <b-modal ref="modal-estorno" 
            id="modal-estorno" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            content-class="border-0 shadow-lg"
            centered
            size="lg"
            @shown="focusModalEstornar()" 
        >
          <b-overlay :show="estorno.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="danger" 
                      spinner-type="border">
            <template #overlay>
              <div class="text-center bg-white p-4 rounded shadow-lg border">
                <b-icon icon="slash-circle" font-scale="3" class="text-danger mb-3" animation="pulse"></b-icon>
                <h5 class="font-weight-bold">Processando Estorno...</h5>
                <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e53e3e 0%, #7d1c1c 100%) !important;">
              <div class="header-icon-wrapper mr-3 bg-white-10">
                  <i class="fa fa-reply text-white"></i>
              </div>
              <div>
                  <h5 class="mb-0 font-weight-bold text-white">Estornar Recebimento</h5>
                  <small class="text-white opacity-75">Anulação de entrada financeira no caixa/banco</small>
              </div>
              <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-estorno')">
                  <i class="fa fa-times fa-lg"></i>
              </b-button>
          </div>

          <div class="p-4 bg-white">
              <!-- Modal Info Bar -->
              <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                  <b-row align-v="center">
                      <b-col md="6">
                          <small class="modal-label-premium">Cliente</small>
                          <h5 class="mb-0 font-weight-bold text-dark">{{estorno.dados.nomeCliente}}</h5>
                      </b-col>
                      <b-col md="3" class="border-left">
                          <small class="modal-label-premium">Documento / Parcela</small>
                          <h5 class="mb-0 font-weight-bold text-primary">{{estorno.dados.documento}} - {{estorno.dados.parcela}}</h5>
                          <small class="text-muted font-weight-bold">Pago em: {{estorno.dados.dataRecebimento}}</small>
                      </b-col>
                      <b-col md="3" class="border-left text-right">
                          <small class="modal-label-premium">Valor Recebido</small>
                          <h5 class="mb-0 font-weight-bold text-danger">{{formatCurrency(estorno.dados.valorRecebido)}}</h5>
                      </b-col>
                  </b-row>
              </div>

              <div v-if="estorno.parametros.permissao === false" class="alert bg-soft-danger border-danger text-danger text-center p-4 rounded-lg shadow-xs mt-3">
                  <i class="fa fa-lock fa-3x mb-3"></i>
                  <h4 class="font-weight-bold mb-1">ACESSO NEGADO</h4>
                  <p class="mb-0">Você não possui permissões suficientes para realizar o estorno deste recebimento.</p>
              </div>

              <template v-else>
                  <div class="modal-section-title mb-3">
                      <i class="fa fa-commenting mr-2 text-danger"></i> Justificativa do Estorno
                  </div>
                  <div class="p-3 bg-light rounded border mb-3 shadow-xs">
                       <label class="modal-label-premium">Motivo do Estorno <span class="text-danger">*</span></label>
                       <b-form-input 
                          ref="motivoEstorno" 
                          id="motivoEstorno" 
                          v-model="estorno.dados.motivo" 
                          :state="validouCampo_motivoEstorno"
                          placeholder="Informe detalhadamente o porquê deste estorno..."
                          class="rounded-pill shadow-xs"
                          @keydown.enter.native="estornar()"
                       ></b-form-input>
                       <small class="text-muted mt-2 d-block"><i class="fa fa-info-circle mr-1"></i> Esta ação irá reabrir o título no Contas a Receber.</small>
                  </div>
              </template>

              <div class="modal-section-title mb-3">
                  <i class="fa fa-money mr-2 text-primary"></i> Resumo de Valores
              </div>
              
              <b-row>
                  <b-col md="6">
                      <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                          <small class="modal-label-premium">Valor do Documento</small>
                          <h5 class="mb-0 font-weight-bold text-dark">{{formatCurrency(estorno.dados.valorDocumento)}}</h5>
                      </div>
                  </b-col>
                  <b-col md="6">
                      <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-danger border-2">
                          <small class="modal-label-premium text-danger">Valor a Estornar</small>
                          <h4 class="mb-0 font-weight-bold text-danger">{{formatCurrency(estorno.dados.valorRecebido)}}</h4>
                      </div>
                  </b-col>
              </b-row>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
              <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-estorno')">
                  CANCELAR
              </b-button>
              <b-button v-if="estorno.parametros.permissao === true" variant="danger" pill class="px-5 font-weight-bold shadow-sm" @click="estornar()">
                  <i class="fa fa-check-circle mr-1"></i> CONFIRMAR ESTORNO
              </b-button>
          </div>
        </b-modal>
      </div>
    </div>
    
    <!-- Modal de Confirmação para Resultados Grandes -->
    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />

    <!--  -----------------------------------------------------------------------------------
                                       MODAL DETALHES DA BAIXA 
          ----------------------------------------------------------------------------------- -->
    <b-modal ref="modal-detalhes" 
        id="modal-detalhes" 
        hide-header
        hide-footer
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        centered 
        size="lg"
    >
      <!-- Header Premium -->
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-info-circle text-white"></i>
          </div>
          <div>
              <h5 class="mb-0 font-weight-bold text-white">Detalhes do Recebimento</h5>
              <small class="text-white opacity-75">Informações completas do título baixado</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-detalhes'].hide()">
              <i class="fa fa-times fa-lg"></i>
          </b-button>
      </div>

      <div class="p-4 bg-white">
          <!-- Modal Info Bar -->
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
              <b-row align-v="center">
                  <b-col md="6">
                      <small class="modal-label-premium">Cliente Pagador</small>
                      <h5 class="mb-0 font-weight-bold text-dark">{{detalhe.COD_CLI}} - {{detalhe.DESCRICAO || detalhe.NOME_CLIENTE || '—'}}</h5>
                  </b-col>
                  <b-col md="3" class="border-left">
                      <small class="modal-label-premium">Documento / Parcela</small>
                      <h5 class="mb-0 font-weight-bold text-primary">{{detalhe.DOCUMENTO}} / {{detalhe.PARCELA}}</h5>
                  </b-col>
                  <b-col md="3" class="border-left text-right">
                      <small class="modal-label-premium text-success">Valor Recebido</small>
                      <h4 class="mb-0 font-weight-bold text-success">{{formatCurrency(detalhe.VL_BAIXA)}}</h4>
                  </b-col>
              </b-row>
          </div>

          <!-- Section 1: Dados do Título -->
          <div class="modal-section-title mb-3">
              <i class="fa fa-file-text-o mr-2 text-success"></i> Informações do Título
          </div>
          <div class="p-3 bg-light rounded border mb-4 shadow-xs">
              <b-row>
                  <b-col md="3" class="mb-2">
                      <small class="modal-label-premium">Emissão</small>
                      <span class="font-weight-bold">{{detalhe.DT_DOC ? moment(String(detalhe.DT_DOC)).format('DD/MM/YYYY') : '—'}}</span>
                  </b-col>
                  <b-col md="3" class="mb-2">
                      <small class="modal-label-premium">Vencimento</small>
                      <span class="font-weight-bold">{{detalhe.DT_RECEBARECEBER ? moment(String(detalhe.DT_RECEBARECEBER)).format('DD/MM/YYYY') : '—'}}</span>
                  </b-col>
                  <b-col md="3" class="mb-2">
                      <small class="modal-label-premium">Valor Original</small>
                      <span class="font-weight-bold">{{formatCurrency(detalhe.VL_DOC)}}</span>
                  </b-col>
                  <b-col md="3" class="mb-2">
                      <small class="modal-label-premium">Boleto ID</small>
                      <span class="font-weight-bold">{{detalhe.BOLETO_ID || '—'}}</span>
                  </b-col>
              </b-row>
          </div>

          <!-- Section 2: Dados do Recebimento -->
          <div class="modal-section-title mb-3">
              <i class="fa fa-check-square-o mr-2 text-success"></i> Dados do Recebimento
          </div>
          <div class="p-3 bg-light rounded border mb-4 shadow-xs">
              <b-row class="mb-3">
                  <b-col md="3">
                      <small class="modal-label-premium">Data de Baixa</small>
                      <span class="font-weight-bold">{{detalhe.DT_BAIXA ? moment(String(detalhe.DT_BAIXA)).format('DD/MM/YYYY') : '—'}}</span>
                  </b-col>
                  <b-col md="3">
                      <small class="modal-label-premium">Data do Sistema</small>
                      <span class="font-weight-bold">{{detalhe.DT_SISTEMA ? moment(String(detalhe.DT_SISTEMA)).format('DD/MM/YYYY') : '—'}}</span>
                  </b-col>
                  <b-col md="3">
                      <small class="modal-label-premium">Usuário Baixa</small>
                      <span class="font-weight-bold">{{detalhe.USUARIO || '—'}}</span>
                  </b-col>
                  <b-col md="3">
                      <small class="modal-label-premium">Tipo de Baixa</small>
                      <b-badge :variant="colorirTipoBaixa(detalhe.TIPO_BAIXA)" pill>{{detalhe.TIPO_BAIXA}}</b-badge>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col md="6">
                      <small class="modal-label-premium">Forma de Pagamento</small>
                      <b-badge pill class="px-2 py-1 shadow-xs" :variant="variantTipoPagamento(detalhe.OP_TIPO_PAGAMENTO)">
                          <i :class="iconeTipoPagamento(detalhe.OP_TIPO_PAGAMENTO)" class="mr-1"></i>
                          {{ descricaoTipoPagamento(detalhe.OP_TIPO_PAGAMENTO) }}
                      </b-badge>
                  </b-col>
                  <b-col md="6">
                      <small class="modal-label-premium">Conta / Banco Destino</small>
                      <span class="font-weight-bold">{{detalhe.COD_CONTA || '—'}}</span>
                  </b-col>
              </b-row>
          </div>

          <!-- Section 3: Valores Detalhados -->
          <div class="modal-section-title mb-3">
              <i class="fa fa-money mr-2 text-success"></i> Valores e Ajustes
          </div>
          <div class="p-3 bg-light rounded border mb-4 shadow-xs">
              <b-row class="mb-2">
                  <b-col md="4">
                      <small class="modal-label-premium">Valor Pago</small>
                      <span class="font-weight-bold text-success" style="font-size: 1.1rem;">{{formatCurrency(detalhe.VL_BAIXA)}}</span>
                  </b-col>
                  <b-col md="4">
                      <small class="modal-label-premium">Multa / Juros</small>
                      <span class="font-weight-bold text-danger">{{formatCurrency(detalhe.VL_MULTA)}}</span>
                  </b-col>
                  <b-col md="4">
                      <small class="modal-label-premium">Desconto</small>
                      <span class="font-weight-bold text-primary">{{formatCurrency(detalhe.VL_DESCONTO)}}</span>
                  </b-col>
              </b-row>
              <b-row v-if="detalhe.VL_MULTA > 0 || detalhe.VL_DESCONTO > 0" class="mt-2 pt-2 border-top">
                  <b-col md="6" v-if="detalhe.VL_MULTA > 0">
                      <small class="modal-label-premium">Observação Multa</small>
                      <span class="small text-muted">{{detalhe.MULTA || 'Não informado'}}</span>
                  </b-col>
                  <b-col md="6" v-if="detalhe.VL_DESCONTO > 0">
                      <small class="modal-label-premium">Observação Desconto</small>
                      <span class="small text-muted">{{detalhe.OBS_DESCONTO || 'Não informado'}}</span>
                  </b-col>
              </b-row>
          </div>

          <!-- Section 4: Dados Específicos PIX -->
          <div v-if="detalhe.OP_TIPO_PAGAMENTO === '6' || detalhe.TX_TIPO_PAGAMENTO === 'PIX'" class="mt-3">
              <div class="modal-section-title mb-3">
                  <i class="fa fa-qrcode mr-2 text-success"></i> Detalhes do Recebimento PIX
              </div>
              <div class="p-3 bg-light rounded border mb-0 shadow-xs">
                  <b-row>
                      <b-col md="4">
                          <small class="modal-label-premium">Tipo de Chave PIX</small>
                          <span class="font-weight-bold">{{formatarTipoChavePix(detalhe.OP_TIPO_PIX)}}</span>
                      </b-col>
                      <b-col md="4">
                          <small class="modal-label-premium">Nome do Pagador</small>
                          <span class="font-weight-bold">{{detalhe.NOME_PAGADOR_PIX || '—'}}</span>
                      </b-col>
                      <b-col md="4">
                          <small class="modal-label-premium">Banco de Origem</small>
                          <span class="font-weight-bold">{{detalhe.BANCO_NOME || detalhe.BANCO_FEBRABAN_PIX_ID || '—'}}</span>
                      </b-col>
                  </b-row>
              </div>
          </div>
      </div>

      <!-- Footer Premium -->
      <div class="modal-header-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="secondary" pill class="px-5 font-weight-bold shadow-sm" @click="$refs['modal-detalhes'].hide()">
              FECHAR
          </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import {Money} from 'v-money'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    Money,
    SetFilter,
    ModalAlertaResultadoGrande,
    CecInputData
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'DOCUMENTO', type: 'number', label: 'Documento' },
      { key: 'PARCELAS', type: 'string', label: 'Parcela' },
      { key: 'ITENS', type: 'string', label: 'Descrição' },
      { key: 'TIPO_BAIXA', type: 'string', label: 'Tipo' },
      { key: 'NOME_CLIENTE', type: 'string', label: 'Fornecedor' },
      { key: 'DT_VENCAPAGAR', type: 'date', label: 'Vencimento'},
      { key: 'DT_BAIXA', type: 'date', label: 'Pagamento'},
      { key: 'DT_SISTEMA', type: 'date', label: 'Sistema'},
      { key: 'VL_DOC', type: 'number', label: 'VL. Doc'},
      { key: 'VL_BAIXA', type: 'number', label: 'VL. Pago'}
    ]
  })],
  data () {
    return {
      filtro: {
        avancado: false
      },
      optionsSituacao: [
        { value: 'D', text: 'Data Documento' },
        { value: 'V', text: 'Data Recebimento' },
        { value: 'S', text: 'Data Sistema' }
      ],
      
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      pesquisa: {
        id: '',
        documento: '',
        situacao: '1',
        clienteId: null,
        dt1: new Date().toJSON().slice(0, 10),
        dt2: new Date().toJSON().slice(0, 10)
      },
      isLoading: false,
      status: '',
      isBusy: false,
      isBusyListagem: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      estorno: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          recebidoId: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataRecebimento: 0.00,
          valorRecebido: 0.00,
          valorDocumento: 0.00,
          valorRecebido2: 0.00,
          valorDocumento2: 0.00,
          usuario: ''
        }
      },
      tabelaListagem: {
        items: [],
        fields: [
          {
            key: "DOCUMENTO",
            label: 'Documento',
            sortable: true,
            thStyle: { width: '10% !important'}
          },
          {
            key: "PARCELA",
            label: 'Parc.',
            sortable: true ,
            thStyle: { width: '5% !important'} 
          },
          {
            key: "OP_TIPO_PAGAMENTO",
            label: 'Tipo Pgto',
            class:'align-middle text-center',
            sortable: true,
            thStyle: { width: '8% !important'}
          },
          {
            key: "TIPO_BAIXA",
            class:'align-middle text-center p-0',
            label: 'Tipo',
            sortable: true
          },
          {
            key: "ITENS",
            label: 'Descrição',
            sortable: true,
            thStyle: { width: '15% !important'} 
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente',
            sortable: true,
            thStyle: { width: '15% !important'}  
          },
          {
            key: "USUARIO",
            label: 'Usuario',
            sortable: true
          },
          {
            key: "DT_DOC",
            label: 'Data Doc.', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY')  : null
          },
          
          {
            key: "DT_RECEBARECEBER",
            label: 'Vencimento', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY')  : null
          },
          {
            key: "DT_BAIXA",
            label: 'Pagamento', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY')  : null
          },
          {
            key: "DT_SISTEMA",
            label: 'dt. Sistema', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY')  : null
          },
          {
            key: 'VL_DOC', 
            class:'text-right', 
            label: 'Original (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_BAIXA', 
            class:'text-right', 
            label: 'Vl. Pago (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'align-middle text-center p-0',
            thStyle: { width: '5% !important'} 
          }
        ]
      },
      sortBy: null,
      sortDesc: false,
      filter: null,
      detalhe: {}
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    vlPagoRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_BAIXA) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    vlDocRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_DOC) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    currentPage: {
      
      get () {
        return this.$store.getters['recebido/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_PAGINA_ATUAL", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['recebido/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('recebido/SET_PER_PAGE', Number(v) || 25)
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['recebido/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_PAGINA_ATUAL", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['recebido/DT1']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['recebido/DT2']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['recebido/ID']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_ID", value);
      }
    },
    documento: {
      get () {
        return this.$store.getters['recebido/DOCUMENTO']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_DOCUMENTO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['recebido/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_CLIENTE_ID", value);
      }
    },
    tipoData: {
      get () {
        return this.$store.getters['recebido/TIPO_DATA']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_TIPO_DATA", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['recebido/LISTA']
      }, 
      set (value) {
        this.$store.commit("recebido/SET_LISTA", value);
      }
    },
    validouCampo_motivoEstorno () {      
      let retorno = null
      if (!this.estorno.dados.motivo  && this.estorno.dados.motivo === null)   { retorno = false }
      return  retorno
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      const val = typeof value === 'string' ? parseFloat(value) : value;
      return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    limpar() {
      this.$store.commit("recebido/SET_LIMPAR", null)
    },
    colorirTipoBaixa(tipo) {
      let valor = tipo?.trim()
      switch (valor) {
        case 'PARCIAL': return 'info'
        case 'BAIXA': return 'success'
        default:
          return ''
      }
    },
    descricaoTipoPagamento(tipo) {
      let valor = String(tipo || '').trim()
      switch (valor) {
        case '0': return 'Dinheiro'
        case '1': return 'Depósito'
        case '2': return 'Boleto'
        case '3': return 'Cheque'
        case '4': return 'Cartão'
        case '5': return 'Adiantamento'
        case '6': return 'PIX'
        default: return '-'
      }
    },
    iconeTipoPagamento(tipo) {
      let valor = String(tipo || '').trim()
      switch (valor) {
        case '0': return 'fa fa-money'
        case '1': return 'fa fa-university'
        case '2': return 'fa fa-barcode'
        case '3': return 'fa fa-file-text-o'
        case '4': return 'fa fa-credit-card'
        case '5': return 'fa fa-exchange'
        case '6': return 'fa fa-mobile'
        default: return ''
      }
    },
    variantTipoPagamento(tipo) {
      let valor = String(tipo || '').trim()
      switch (valor) {
        case '0': return 'success'
        case '1': return 'info'
        case '2': return 'warning'
        case '3': return 'secondary'
        case '4': return 'primary'
        case '5': return 'indigo'
        case '6': return 'purple'
        default: return 'secondary'
      }
    },
    /**************************************************************************************************
     * *************** MODAL PAGAMENTOS **************************************************************
     * *************************************************************************************************/
    async abrirModalEstorno(titulo) {
      this.$store.commit("recebido/SET_REGISTRO_SELECIONADO_ID", titulo.SEQUENCIA)

      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'AcPropReporDocRecebido'
      }

      try {
        let permissaoResult = null
        try {
          this.$store.commit('controle/setAguardando', true)
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.estorno.parametros.permissao = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário sem permissão para estornar')
        } else {

          this.estorno.dados.recebidoId = titulo.SEQUENCIA
          this.estorno.dados.nomeCliente = titulo.NOME_CLIENTE
          this.estorno.dados.parcela = titulo.PARCELA
          this.estorno.dados.documento = titulo.DOCUMENTO
          this.estorno.dados.motivo = ''
          this.estorno.dados.dataRecebimento = moment(String(titulo.DT_BAIXA)).format('DD/MM/YYYY')
          this.estorno.dados.valorRecebido = titulo.VL_BAIXA
          this.estorno.dados.valorDocumento = titulo.VL_DOC
          this.estorno.dados.valorRecebido2 = titulo.VL_BAIXA.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          this.estorno.dados.valorDocumento2 = titulo.VL_DOC.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          this.estorno.dados.usuario = titulo.USUARIO
             
          this.estorno.parametros.permissao = true
          this.estorno.parametros.processando = false
          this.estorno.parametros.busy = true
          this.$refs['modal-estorno'].show()
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    focusModalEstornar() {
      this.$refs.motivoEstorno.focus()
    },
    async clicarLinha(item) {
      this.$store.commit("recebido/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.get(`/api/protected/recebido/detalhar/${item.SEQUENCIA}`)
        if (response && response.data) {
          this.detalhe = response.data
          this.$refs['modal-detalhes'].show()
        } else {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível carregar os detalhes do recebimento.')
        }
      } catch (err) {
        console.error(err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data?.erro || err.message || 'Erro ao consultar detalhes.')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    formatarTipoChavePix(tipo) {
      const t = String(tipo || '').trim()
      switch (t) {
        case '0': return 'CPF/CNPJ'
        case '1': return 'Celular'
        case '2': return 'Email'
        case '3': return 'Aleatória'
        default: return '-'
      }
    },
    moment(...args) {
      return moment(...args);
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['recebido/REGISTRO_SELECIONADO_ID']
      return item.SEQUENCIA === selId ? 'cec-row-selected' : ''
    },
    async pesquisar() {
      // Previne pesquisa se o modal de confirmação estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$store.dispatch('recebido/GERAR_LISTA')
        
        // Verifica se precisa de confirmação devido ao limite de registros
        if (result.needsConfirmation) {
          // Fecha o aguardando antes de exibir o modal
          this.$store.commit('controle/setAguardando', false)
          
          // Armazena os dados para uso posterior
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          
          // Exibe o modal de confirmação
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        // Resultado carregado normalmente
        this.status = true
      } catch (error) {
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.tabelaListagem.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Contas Recebidas',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2} - Tipo: ${this.tipoData === 'D' ? 'Data Documento' : 'Data Pagamento'}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.tabelaListagem.fields,
        filename: 'contas_recebidas.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.tabelaListagem.fields,
        filename: 'contas_recebidas.csv',
      });
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      
      try {
        await this.$store.dispatch('recebido/GERAR_LISTA', { skipConfirmation: true })
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
    },
    async estornar() {
      if ( !this.estorno.dados.motivo || this.estorno.dados.motivo.trim() === '') {
        this.$root.$bvToast.toast('Informe o motivo!!!', {
              title: 'Aviso',
              toaster: "b-toaster-top-center",
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
        })
        return
      }

      const estornarPayLoad = {
        recebidoId:  this.estorno.dados.recebidoId,
        documento: this.estorno.dados.documento,
        parcela: this.estorno.dados.parcela,
        login: window.localStorage.getItem('login'),
        motivo:  this.estorno.dados.motivo
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.post('/api/protected/recebido/estornar', estornarPayLoad)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Estornar', 'danger', err)
          return
        }

        
        try {
          await this.$store.dispatch('recebido/GERAR_LISTA')
          this.status = true
        } catch {
          this.status = false
        }
        this.$refs['modal-estorno'].hide()

        Tools.exibirMensagem(this.$store, 'Estornar', 'success', 'Documento estornado com sucesso!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    }
  },
  async created () {
    this.$refs.edDT1?.focus()
  },
  async mounted () {
    await this.pesquisar()
    
    this.$store.commit('controle/setAguardando', false)
    this.$nextTick(() => {
      this.$refs.edDT1?.focus()
    })
  },
  watch: {
  }
}
</script>
<style>
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky */
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6 !important;
}

.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  background-color: #f8f9fa !important;
}

/* Estilos Premium Financeiros */
.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.bg-white-10 {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

</style>
<style scoped>
/* Ajustes finos para aproximar o visual da tabela ao padrão de VendaListagem */
.page-col .table.table-sm th,
.page-col .table.table-sm td {
  padding: 0.22rem 0.5rem; /* menor para reduzir altura da linha */
  vertical-align: middle;
}
.page-col .table.table-sm thead th {
  background-color: transparent; /* deixa o conteúdo em branco quando em tema claro */
}
.page-col .table.table-sm tbody tr {
  background-color: transparent !important; /* evita faixas cinza */
}
.page-col .table.table-sm tbody td {
  border-bottom: 1px solid #dcdfe0; /* linha horizontal entre registros */
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/contasrecebidas/RecebidasListagem.vue